import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/monitoring/gateway/:gatewayId/emergency/`;

type MutationFnType = typeof mutationFn;

type DTO = {
    parkingId: string;
    gatewayId: string;
};

const mutationFn = ({ parkingId, gatewayId }: DTO): Promise<void> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, gatewayId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useEmergencyOpenGateway };
